import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-radio-button-cod-marcio-formly',
    templateUrl: './radio-button-cod-marcio-formly.component.html',
    styleUrls: ['./radio-button-cod-marcio-formly.component.scss'],
    imports: [MatRadioGroup, FormsModule, ReactiveFormsModule, MatRadioButton, AsyncPipe]
})
export class RadioButtonCodMarcioFormlyComponent extends FieldType<FieldTypeConfig> {

}
